import { HttpHelper } from "@/helper/HttpHelper";
import Cookies from 'js-cookie';

const getToken = () =>
    Cookies.get('token') ||
    (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null);

// Create Article First Step API
export const createArticleFirstStepAPI = async (request) => {
    const {content, keyTakeaways, sources, articleId} = await request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/content/create';
    const body = {
        content: content,
        takeaways: keyTakeaways,
        sources: sources
    }
    // In edit mode, send article_id so the backend treats this as an update
    if (articleId) {
        body.article_id = articleId;
    }
    const response = await HttpHelper.post(apiUrl, body, { headers }).then((response) => response.data);
    return response;
}

// Create Article Second Step API
export const createArticleSecondStepAPI = async (request) => {
    const {articleId, articleTitle, categories, status, articleExcerpt, imageId} = await request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/content/update';
    const body = {
        article_id: articleId,
        title: articleTitle,
        categories: categories,
        status: status,
        excerpt: articleExcerpt,
        image_id: imageId
    }
    const response = await HttpHelper.post(apiUrl, body, { headers }).then((response) => response.data);
    return response;
}

// Get Editable Article by id API (author/draft editing)
export const getEditableArticle = async (articleId) => {
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/articles/editable/' + articleId;
    const response = await HttpHelper.get(apiUrl, { headers }).then((response) => response.data);
    return response;
}

// Get All Categories API
export async function getAllCategories() {
    const token = getToken();
    var header = {
        Authorization: 'Bearer ' + token
    }
    const apiUrl =  process.env.NEXT_PUBLIC_BASE_URL + '/category/list';
    const response = await HttpHelper.post(apiUrl, {headers : header}).then((response) => response.data);
    return response;
}
